import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../types/common.types';
import { Notification } from '../../types/entity.types';

import { useNotificationApi } from '../../api/notification/useNotificationApi';

import { isToday, retrieveFromLocalStorage } from '../../utils/util';

import Notifications from '../../components/common/notifications/Notifications';

type Props = {
  show: boolean;
};

const NotificationsContainer = ({ show }: Props) => {
  const [todayNotifications, setTodayNotifications] = useState<Notification[]>([]);
  const [previousNotifications, setPreviousNotifications] = useState<Notification[]>([]);

  const { notifications } = useSelector(({ system }: RootState) => system);

  const { viewAllNotifications, queryNewNotifications, viewNewNotifications } = useNotificationApi();

  useEffect(() => {
    const systemUserExternalReference = retrieveFromLocalStorage('user');
    viewAllNotifications({ systemUserExternalReference });
  }, [viewAllNotifications]);

  useEffect(() => {
    const systemUserExternalReference = retrieveFromLocalStorage('user');

    const interval = setInterval(() => {
      if (notifications.length === 0) {
        viewAllNotifications({ systemUserExternalReference });
      } else {
        const lastNotification = notifications[0] as Notification;
        const lastNotificationUUID = lastNotification.externalReference;

        queryNewNotifications({ systemUserExternalReference, lastNotificationUUID }, (areNewNotifications) => {
          if (areNewNotifications) {
            viewNewNotifications({ systemUserExternalReference, lastNotificationUUID });
          }
        });
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [viewAllNotifications, queryNewNotifications, viewNewNotifications, notifications]);

  useEffect(() => {
    const todayNotifications: Notification[] = [];
    const previousNotifications: Notification[] = [];

    notifications.forEach((notification) => {
      if (isToday(notification.date)) {
        todayNotifications.push(notification);
      } else {
        previousNotifications.push(notification);
      }
    });

    setTodayNotifications(todayNotifications);
    setPreviousNotifications(previousNotifications);
  }, [notifications]);

  return (
    <Notifications show={show} todayNotifications={todayNotifications} previousNotifications={previousNotifications} />
  );
};

export default NotificationsContainer;
